import { AGENT, BOT, SYSTEM, VISITOR } from 'conversations-message-history/common-message-format/constants/legacySenderTypes';
import FormattedName from 'I18n/components/FormattedName';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import { getEmail, getFirstName, getLastName, getSenderType } from 'conversations-message-history/senders/operators/getters';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
export const UnknownSenderText = ({
  sender
}) => {
  const senderType = sender && getSenderType(sender);
  switch (senderType) {
    case BOT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.responder.bot"
      });
    case AGENT:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.responder.unknownResponder"
      });
    case VISITOR:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.responder.unknownVisitor"
      });
    case SYSTEM:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.responder.automatic"
      });
    default:
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-visitor-message-history.responder.unknownSender"
      });
  }
};
UnknownSenderText.displayName = 'UnknownSenderText';
const FriendlySenderName = ({
  sender,
  isLoading
}) => {
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      "data-test-id": "skeleton-text",
      inlineSize: "100px"
    });
  }
  const givenName = sender && getFirstName(sender);
  const familyName = sender && getLastName(sender);
  const email = sender && getEmail(sender);
  const hasKnownName = Boolean(givenName || familyName || email);
  return hasKnownName ? /*#__PURE__*/_jsx(FormattedName, {
    givenName: givenName || undefined,
    familyName: familyName || undefined,
    email: email || undefined
  }) : /*#__PURE__*/_jsx(UnknownSenderText, {
    sender: sender
  });
};
FriendlySenderName.displayName = 'SenderName';
export default FriendlySenderName;